import { render, staticRenderFns } from "./ItemPack.vue?vue&type=template&id=4481df67&scoped=true&"
import script from "./ItemPack.vue?vue&type=script&lang=js&"
export * from "./ItemPack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4481df67",
  null
  
)

export default component.exports